// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 242) return "vendor.d3b9ac2c30dd0130d100.js";
	// return url for filenames based on template
	return "" + chunkId + "." + "0f81d768ae4bf0552ae4" + ".bundle.js";
};